import React, {useEffect, useState} from "react";

// core components
import Wizard from "components/Wizard/Wizard.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Step1 from "./Steps/Step1.js";
import Step2 from "./Steps/Step2.js";
import Step3 from "./Steps/Step3.js";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Button from "../../../components/CustomButtons/Button";
import {API_ENDPOINT, API_HEADERS} from "../../../components/constants";
import LoadingSpinner from "../../../components/Microcomponents/LoadingSpinner";
import ScaleLoader from "react-spinners/ScaleLoader";
import DefaultClientPicker from "../ManualClientSelector";
import Step4 from "./Steps/Step4";
import {alertOn422, redirectOn403} from "../../../components/commonFunctions";
import {IncompleteProfileAlert} from "../../../components/helpers";


export default function Wiz_GSS_PermContract() {
    const [noUrlParams, setNoUrlParams] = useState(false);
    const [loadingDefaults, setLoadingDefaults] = useState(true);
    const [clientDefaults, setClientDefaults] = useState(null);
    const [consultantDefaults, setConsultantDefaults] = useState(null);
    const [isCompleted, setCompleted] = useState(false);
    const [fileStatus, setFileStatus] = useState(undefined);
    const [fileLink, setFileLink] = useState(undefined);
    const [defaultsLoadingError, setDefaultsLoadingError] = useState(undefined);
    const [incompleteProfile, setIncompleteProfile] = useState(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        let clientId = queryParams.get("clientId");
        let userEmail = queryParams.get("user");
        let url = `${API_ENDPOINT}/gcp/get_client_document_defaults?clientId=${clientId}`;
        if (userEmail){
            url = url + `&email=${userEmail}`;
        }
        if (clientId){
            axios({
                url,
                headers: API_HEADERS
            }).then( r => {
                if (!r.data.consultant.completeProfile){
                    setIncompleteProfile(true)
                }
                setClientDefaults(r.data.client);
                setConsultantDefaults(r.data.consultant);
                setLoadingDefaults(false);
                setNoUrlParams(false)
            }).catch( err => {
                if (err.response && err.response.status === 404){
                    setDefaultsLoadingError(err.response.data.error)
                }
                redirectOn403(err)
            })
        } else{
            setLoadingDefaults(false);
            setNoUrlParams(true)
        }
    }, [])

    const submit = (allStates) => {
        if (allStates.client){
            setCompleted(true);
            setFileStatus("inCreation")
            let data = {
                client: allStates.client,
                consultant: allStates.consultant,
                terms: allStates.terms,
                others: allStates.others,
                type: "pss_perm_contract"
            }
            axios({
                url: API_ENDPOINT + "/gcp/create_gss_perm_contract/",
                method: 'POST',
                data,
                headers: API_HEADERS
            }).then( r => {
                setFileLink(r.data.webViewLink);
                setFileStatus("ready");
            }).catch( err => {
                setFileStatus("ready");
                alertOn422(err);
                console.log(err)
            })
        }
    }
    return (
        <GridContainer justify="center">
            {noUrlParams
                ? <GridItem xs={12} sm={6}>
                    <DefaultClientPicker onSubmit={ () => setLoadingDefaults(true) }/>
                </GridItem>
                : <GridItem xs={12} sm={8}>
                    {!loadingDefaults
                        ? <Wizard
                            validate
                            steps={[
                                {stepName: "Kunde", stepComponent: Step1, stepId: "client", stepProps: clientDefaults},
                                {stepName: "GULPi", stepComponent: Step2, stepId: "consultant", stepProps: consultantDefaults},
                                {stepName: "Konditionen", stepComponent: Step3, stepId: "terms"},
                                {stepName: "Sonstiges", stepComponent: Step4, stepId: "others"},
                            ]}
                            title="Neuen GSS PV Vertrag erstellen"
                            subtitle="Mit Hilfe dieses Formulars kannst du schnell und einfach konforme GSS PV Verträge erstellen."
                            finishButtonClick={allStates => submit(allStates)}
                        />
                        : <LoadingSpinner message={defaultsLoadingError}/>
                    }
                </GridItem>
            }

            {isCompleted && <SweetAlert
                success={ fileStatus === "ready" }
                style={{ display: "block", marginTop: "-100px" }}
                title={ fileStatus === "inCreation"
                    ? <div><ScaleLoader
                        height={14}
                        width={4}
                        radius={2}
                        margin={4}
                        color="#0097a7"
                    />
                <p>Bitte warten...</p></div>
                    : "Fertig!"
                }
                showConfirm={false}
                onConfirm={ () => true } // required prop...
            >
                {fileStatus === "inCreation"
                    ? "Dein Dokument wird gerade erstellt. Bitte schließe dieses Fenster nicht."
                    : <div>
                        <p>Dein Dokument wird jetzt erstellt und Dir in Kürze per Email geschickt.</p>
                    </div>
                }
            </SweetAlert>}

            {incompleteProfile && <IncompleteProfileAlert/>}
        </GridContainer>
    );
}